// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.results-display {
  margin-bottom: 20px;
}

.score-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 40px;
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
}

.score-circle {
  width: 200px;
  height: 200px;
  border-radius: 50%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border: 8px solid #667eea;
  background: white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.score-number {
  font-size: 3.5rem;
  font-weight: bold;
  color: #333;
}

.score-label {
  font-size: 0.9rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 1px;
}

.verdict-badge {
  padding: 20px;
  border-radius: 8px;
  font-size: 1.3rem;
  font-weight: bold;
  text-align: center;
  min-width: 180px;
}

.verdict-comfortable {
  background-color: #e8f5e9;
  color: #2e7d32;
  border: 2px solid #4caf50;
}

.verdict-stretch {
  background-color: #fff3e0;
  color: #e65100;
  border: 2px solid #ff9800;
}

.verdict-risky {
  background-color: #ffebee;
  color: #c62828;
  border: 2px solid #ff6f00;
}

.verdict-not-advised {
  background-color: #ffcdd2;
  color: #b71c1c;
  border: 2px solid #d32f2f;
}

.score-description {
  margin-top: 10px;
  font-size: 0.9rem;
  color: #666;
}

@media (max-width: 768px) {
  .score-card {
    flex-direction: column;
    gap: 20px;
  }

  .score-circle {
    width: 150px;
    height: 150px;
  }

  .score-number {
    font-size: 2.5rem;
  }
}

.explanation-card {
  margin-top: 20px;
}

.explanation-text {
  line-height: 1.8;
  color: #333;
  font-size: 0.95rem;
}

.explanation-text strong {
  color: #d32f2f;
}

.metrics-card h3,
.market-card h3 {
  color: #333;
  margin-bottom: 20px;
}

.takeaways-card {
  margin-top: 20px;
  background: linear-gradient(180deg, #fff 0%, #f7fbff 100%);
  padding: 16px;
  border-radius: 6px;
  border: 1px solid rgba(102,126,234,0.08);
}

.takeaways-card h3 {
  margin-bottom: 12px;
  color: #23365b;
}

.takeaways-card ul {
  margin: 0;
  padding-left: 18px;
  color: #444;
}

.takeaways-card li {
  margin-bottom: 8px;
  line-height: 1.5;
}

.takeaways-card li strong {
  color: #b71c1c;
}

/* Recommendation card styles */
.recommendation-card {
  margin-top: 20px;
  padding: 16px;
  background: linear-gradient(180deg, #fff 0%, #fff9f5 100%);
  border-radius: 6px;
  border: 1px solid rgba(217,115,36,0.08);
}

.recommendation-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: 16px;
  margin-top: 8px;
}

.recommendation-item {
  background: #fff; 
  padding: 12px;
  border-radius: 4px;
  border-left: 4px solid #ff9800;
}

.recommendation-value {
  font-size: 1.25rem;
  font-weight: 700;
  color: #333;
}

.recommendation-note {
  font-size: 0.85rem;
  color: #666;
  margin-top: 6px;
}

.recommendation-notes {
  margin-top: 12px;
  padding-left: 18px;
  color: #444;
}

.metrics-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
  gap: 20px;
}

.metric {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
  border-left: 4px solid #667eea;
}

.metric label {
  display: block;
  font-size: 0.85rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  font-weight: 600;
}

.metric-value {
  font-size: 1.3rem;
  font-weight: bold;
  color: #333;
}

.metric-value.highlight {
  color: #667eea;
}

.comparison-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
  gap: 15px;
}

.comparison-item {
  background: #f9f9f9;
  padding: 15px;
  border-radius: 4px;
  border-left: 4px solid #667eea;
}

.comparison-item.full-width {
  grid-column: 1 / -1;
}

.comparison-item label {
  display: block;
  font-size: 0.85rem;
  color: #999;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
  font-weight: 600;
}

.comparison-value {
  font-size: 1.3rem;
  font-weight: bold;
  color: #333;
}

.comparison-badge {
  display: inline-block;
  padding: 10px 20px;
  border-radius: 4px;
  font-size: 1rem;
  font-weight: 600;
}

.comparison-badge.below-market {
  background-color: #e8f5e9;
  color: #2e7d32;
}

.comparison-badge.above-market {
  background-color: #ffebee;
  color: #c62828;
}

.comparison-badge.at-market {
  background-color: #e3f2fd;
  color: #1565c0;
}

.actions-card {
  margin-top: 20px;
}

.actions-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 15px;
}

.btn-primary {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border: none;
  padding: 12px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: opacity 0.3s;
}

.btn-primary:hover {
  opacity: 0.9;
}

.btn-secondary {
  background: white;
  color: #667eea;
  border: 2px solid #667eea;
  padding: 10px 20px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 0.95rem;
  font-weight: 600;
  transition: background-color 0.3s;
}

.btn-secondary:hover {
  background-color: #f5f7ff;
}

@media (max-width: 600px) {
  .actions-grid {
    grid-template-columns: 1fr;
  }

  .metrics-grid {
    grid-template-columns: 1fr;
  }
}

.disclaimer {
  margin-top: 30px;
  padding: 15px;
  background: #fff3e0;
  border-left: 4px solid #ff9800;
  border-radius: 4px;
  color: #666;
  font-size: 0.9rem;
  line-height: 1.6;
}
`, "",{"version":3,"sources":["webpack://./src/components/ResultsDisplay.css"],"names":[],"mappings":"AAAA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,6DAA6D;AAC/D;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;EACzB,iBAAiB;EACjB,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE;IACE,sBAAsB;IACtB,SAAS;EACX;;EAEA;IACE,YAAY;IACZ,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,0DAA0D;EAC1D,aAAa;EACb,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA,+BAA+B;AAC/B;EACE,gBAAgB;EAChB,aAAa;EACb,0DAA0D;EAC1D,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,WAAW;EACX,yBAAyB;EACzB,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,YAAY;EACZ,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;AAClB","sourcesContent":[".results-display {\n  margin-bottom: 20px;\n}\n\n.score-card {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 40px;\n  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);\n}\n\n.score-circle {\n  width: 200px;\n  height: 200px;\n  border-radius: 50%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border: 8px solid #667eea;\n  background: white;\n  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);\n}\n\n.score-number {\n  font-size: 3.5rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.score-label {\n  font-size: 0.9rem;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 1px;\n}\n\n.verdict-badge {\n  padding: 20px;\n  border-radius: 8px;\n  font-size: 1.3rem;\n  font-weight: bold;\n  text-align: center;\n  min-width: 180px;\n}\n\n.verdict-comfortable {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n  border: 2px solid #4caf50;\n}\n\n.verdict-stretch {\n  background-color: #fff3e0;\n  color: #e65100;\n  border: 2px solid #ff9800;\n}\n\n.verdict-risky {\n  background-color: #ffebee;\n  color: #c62828;\n  border: 2px solid #ff6f00;\n}\n\n.verdict-not-advised {\n  background-color: #ffcdd2;\n  color: #b71c1c;\n  border: 2px solid #d32f2f;\n}\n\n.score-description {\n  margin-top: 10px;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n@media (max-width: 768px) {\n  .score-card {\n    flex-direction: column;\n    gap: 20px;\n  }\n\n  .score-circle {\n    width: 150px;\n    height: 150px;\n  }\n\n  .score-number {\n    font-size: 2.5rem;\n  }\n}\n\n.explanation-card {\n  margin-top: 20px;\n}\n\n.explanation-text {\n  line-height: 1.8;\n  color: #333;\n  font-size: 0.95rem;\n}\n\n.explanation-text strong {\n  color: #d32f2f;\n}\n\n.metrics-card h3,\n.market-card h3 {\n  color: #333;\n  margin-bottom: 20px;\n}\n\n.takeaways-card {\n  margin-top: 20px;\n  background: linear-gradient(180deg, #fff 0%, #f7fbff 100%);\n  padding: 16px;\n  border-radius: 6px;\n  border: 1px solid rgba(102,126,234,0.08);\n}\n\n.takeaways-card h3 {\n  margin-bottom: 12px;\n  color: #23365b;\n}\n\n.takeaways-card ul {\n  margin: 0;\n  padding-left: 18px;\n  color: #444;\n}\n\n.takeaways-card li {\n  margin-bottom: 8px;\n  line-height: 1.5;\n}\n\n.takeaways-card li strong {\n  color: #b71c1c;\n}\n\n/* Recommendation card styles */\n.recommendation-card {\n  margin-top: 20px;\n  padding: 16px;\n  background: linear-gradient(180deg, #fff 0%, #fff9f5 100%);\n  border-radius: 6px;\n  border: 1px solid rgba(217,115,36,0.08);\n}\n\n.recommendation-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));\n  gap: 16px;\n  margin-top: 8px;\n}\n\n.recommendation-item {\n  background: #fff; \n  padding: 12px;\n  border-radius: 4px;\n  border-left: 4px solid #ff9800;\n}\n\n.recommendation-value {\n  font-size: 1.25rem;\n  font-weight: 700;\n  color: #333;\n}\n\n.recommendation-note {\n  font-size: 0.85rem;\n  color: #666;\n  margin-top: 6px;\n}\n\n.recommendation-notes {\n  margin-top: 12px;\n  padding-left: 18px;\n  color: #444;\n}\n\n.metrics-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));\n  gap: 20px;\n}\n\n.metric {\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 4px;\n  border-left: 4px solid #667eea;\n}\n\n.metric label {\n  display: block;\n  font-size: 0.85rem;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.metric-value {\n  font-size: 1.3rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.metric-value.highlight {\n  color: #667eea;\n}\n\n.comparison-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));\n  gap: 15px;\n}\n\n.comparison-item {\n  background: #f9f9f9;\n  padding: 15px;\n  border-radius: 4px;\n  border-left: 4px solid #667eea;\n}\n\n.comparison-item.full-width {\n  grid-column: 1 / -1;\n}\n\n.comparison-item label {\n  display: block;\n  font-size: 0.85rem;\n  color: #999;\n  text-transform: uppercase;\n  letter-spacing: 0.5px;\n  margin-bottom: 8px;\n  font-weight: 600;\n}\n\n.comparison-value {\n  font-size: 1.3rem;\n  font-weight: bold;\n  color: #333;\n}\n\n.comparison-badge {\n  display: inline-block;\n  padding: 10px 20px;\n  border-radius: 4px;\n  font-size: 1rem;\n  font-weight: 600;\n}\n\n.comparison-badge.below-market {\n  background-color: #e8f5e9;\n  color: #2e7d32;\n}\n\n.comparison-badge.above-market {\n  background-color: #ffebee;\n  color: #c62828;\n}\n\n.comparison-badge.at-market {\n  background-color: #e3f2fd;\n  color: #1565c0;\n}\n\n.actions-card {\n  margin-top: 20px;\n}\n\n.actions-grid {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 15px;\n}\n\n.btn-primary {\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n  color: white;\n  border: none;\n  padding: 12px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: opacity 0.3s;\n}\n\n.btn-primary:hover {\n  opacity: 0.9;\n}\n\n.btn-secondary {\n  background: white;\n  color: #667eea;\n  border: 2px solid #667eea;\n  padding: 10px 20px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 0.95rem;\n  font-weight: 600;\n  transition: background-color 0.3s;\n}\n\n.btn-secondary:hover {\n  background-color: #f5f7ff;\n}\n\n@media (max-width: 600px) {\n  .actions-grid {\n    grid-template-columns: 1fr;\n  }\n\n  .metrics-grid {\n    grid-template-columns: 1fr;\n  }\n}\n\n.disclaimer {\n  margin-top: 30px;\n  padding: 15px;\n  background: #fff3e0;\n  border-left: 4px solid #ff9800;\n  border-radius: 4px;\n  color: #666;\n  font-size: 0.9rem;\n  line-height: 1.6;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
